import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filters from 'views/customers/configuration/securityChanges/filter'; // Importing Filters component
import Table from 'views/customers/configuration/securityChanges/table'; // Importing Table component
import SecurityForm from 'views/customers/configuration/securityChanges/securityForm'; // Importing SecurityForm component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the limit change view.
 * @extends JetView
 */
export default class limitChangeView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size
                },
            ],
        };
        const left = {
            // Left side layout configuration
            rows: [
                {
                    view: 'toolbar', // Toolbar for section title
                    css: theme,
                    elements: [{ view: 'label', label: _('Limites') }], // Label for 'Limits'
                },
                {
                    view: 'form', // Form for limit changes
                    css: theme,
                    id: 'formLimitChanges', // Form ID
                    elements: [
                        {
                            cols: [
                                // Columns for input fields
                                {
                                    view: 'text', // Input for Casino limit
                                    id: 'LimitCasino',
                                    name: 'LimitCasino',
                                    type: 'float',
                                    label: "<div class='tittle'>" + _('Casino') + '</div>',
                                    labelPosition: 'top',
                                    defaultValue: 0, // Default value
                                },
                                {
                                    view: 'text', // Input for Live Casino limit
                                    id: 'LimitLiveCasino',
                                    name: 'LimitLiveCasino',
                                    type: 'float',
                                    label: "<div class='tittle'>" + _('Live casino') + '</div>',
                                    labelPosition: 'top',
                                    defaultValue: 0, // Default value
                                },
                                {
                                    view: 'text', // Input for Sportsbook limit
                                    id: 'LimitSportbook',
                                    name: 'LimitSportbook',
                                    type: 'float',
                                    label: "<div class='tittle'>" + _('Sportbook') + '</div>',
                                    labelPosition: 'top',
                                    defaultValue: 0, // Default value
                                },
                                {
                                    view: 'text', // Input for Virtuals limit
                                    id: 'LimitVirtuals',
                                    name: 'LimitVirtuals',
                                    type: 'float',
                                    label: "<div class='tittle'>" + _('Virtuales') + '</div>',
                                    labelPosition: 'top',
                                    defaultValue: 0, // Default value
                                },
                            ],
                        },
                        {
                            cols: [
                                // Additional columns for input fields
                                {
                                    view: 'text', // Input for Deposits limit
                                    id: 'LimitDeposits',
                                    name: 'LimitDeposits',
                                    type: 'float',
                                    label: "<div class='tittle'>" + _('Depósitos') + '</div>',
                                    labelPosition: 'top',
                                    defaultValue: 0, // Default value
                                },
                                {
                                    view: 'text', // Input for Withdrawals limit
                                    id: 'LimitWithdrawals',
                                    name: 'LimitWithdrawals',
                                    type: 'float',
                                    label: "<div class='tittle'>" + _('Retiros') + '</div>',
                                    labelPosition: 'top',
                                    defaultValue: 0, // Default value
                                },
                                {},
                                {},
                            ],
                        },
                        {
                            cols: [
                                // Button for saving changes
                                {
                                    view: 'button',
                                    value: _('Guardar'), // Button label
                                    css: 'webix_primary',
                                    click: () => {
                                        // Click event handler
                                        const form = this.getRoot().queryView({
                                            view: 'form', // Querying the form
                                        });
                                        const values = form.getValues(); // Getting form values
                                        this.app.callEvent(
                                            'save:limitChanges', // Triggering save event
                                            [values],
                                        );
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        return {
            // Returning the main configuration
            type: 'wide',
            cols: [left],
        };
    }

    /**
     * Initializes the view and fetches user data.
     * @param {Object} view - The view instance.
     */
    init(view) {
        const cur_user = this.getParam('user', true); // Getting current user ID
        webix.ajax().get(
            devConfig.geturlApi() + 'Client/GetClientById', // API call to get client data
            'id=' + cur_user,
            {
                error: function (text, data, XmlHttpRequest) {
                    // Error handling
                    webix.message('Error! ');
                },
                success: function (text, data, XmlHttpRequest) {
                    // Success handling
                    var response = JSON.parse(text); // Parsing response
                    $$('LimitCasino').setValue(response[0].LimitCasino); // Setting Casino limit
                    $$('LimitLiveCasino').setValue(
                        response[0].LimitLiveCasino, // Setting Live Casino limit
                    );
                    $$('LimitSportbook').setValue(
                        response[0].LimitSportbook, // Setting Sportsbook limit
                    );
                    $$('LimitVirtuals').setValue(response[0].LimitVirtuals); // Setting Virtuals limit
                    $$('LimitDeposits').setValue(response[0].LimitDeposits); // Setting Deposits limit
                    $$('LimitWithdrawals').setValue(
                        response[0].LimitWithdrawals, // Setting Withdrawals limit
                    );
                },
            },
        );
        this.on(this.app, 'save:limitChanges', (values) => {
            // Listening for save event
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Setting content type for request
                })
                .post(
                    devConfig.geturlApi() + 'Client/UpdateUserLimits', // API call to update user limits
                    { id: cur_user, ...values }, // Sending user ID and values
                    {
                        error: function (text, data, XmlHttpRequest) {
                            // Error handling
                            webix.message('Error! ');
                        },
                        success: function (text, data, XmlHttpRequest) {
                            // Success handling
                            webix.message('Guardado con exito'); // Success message
                            let dataResponse = JSON.parse(text); // Parsing response
                            if (!dataResponse.HasError) {
                                // Checking for errors
                                webix.message({
                                    text: _('Informacíon Actualizada'), // Update message
                                    title: _('¡Exito!'), // Title for message
                                    type: 'alert-warning', // Message type
                                });
                            }
                        },
                    },
                );
        });
    }
}

// FILE DOCUMENTED
